<script setup lang="ts">
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import {Dialog, QInput, useDialogPluginComponent} from "quasar";
import Translator, {ElementTranslationInfo} from "@/utils/common/Translator.ts";
import {ref, Ref} from "vue";
import GenTranslationsDialog from "@/components/dialogs/GenTranslationsDialog.vue";
import TopPanelSearchUtils from "@/utils/common/TopPanelSearchUtils.ts";

const props = defineProps<{ enumTypeName: string, allowedValues: string[] }>()
const {dialogRef, onDialogCancel} = useDialogPluginComponent()

const arabicTexts: Ref<string>[] = props.allowedValues.map(() => ref(''));
const englishTexts: Ref<string>[] = props.allowedValues.map(() => ref(''));

function onExportTranslationsClick() {
  const translations: ElementTranslationInfo[] = [];
  for (let i = 0; i < props.allowedValues.length; i++) {
    let id = props.allowedValues[i];
    let enumTypeName = props.enumTypeName;
    translations.push({
      id: enumTypeName + "." + id,
      currentArabic: Translator.translateIdAr(id, enumTypeName),
      currentEnglish: Translator.translateIdEn(id, enumTypeName),
      arabicText: arabicTexts[i].value,
      englishText: englishTexts[i].value,
      finalId: Translator.calcTranslatedFinalId(enumTypeName + "." + id),
    })
  }
  Dialog.create({
    component: GenTranslationsDialog,
    componentProps: {
      translations,
      presenter: () => TopPanelSearchUtils.findAnyEditPresenter()
    }
  })
}


</script>

<template>
  <q-dialog ref="dialogRef" transition-hide="jump-down" transition-show="jump-up">
    <q-card class="tw-relative tw-flex tw-flex-col !tw-max-h-[80vh] tw-w-[450px] dark:tw-bg-namaBackground-deep-dark tw-px-4 tw-py-3 !tw-rounded-xl">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-items-center tw-gap-2">
          <NamaIcon default-icon="nm-edit-text" class=""/>
          <p v-text="'Edit Translation of Enum - '+ enumTypeName"
             class="tw-text-lg tw-font-semibold tw-leading-none dark:tw-text-white"/>
        </div>
        <q-avatar square class="tw-size-5  tw-cursor-pointer" @click="onDialogCancel">
          <DialogCloseIcon/>
        </q-avatar>
      </div>
      <q-separator class="tw-my-3 dark:tw-bg-white/10"/>
      <div class="tw-flex tw-flex-col tw-overflow-y-auto tw-max-h-[inherit]">
        <q-card-section class="!tw-p-2 tw-w-full tw-flex tw-flex-col tw-gap-2 tw-items-center tw-overflow-y-auto tw-max-w-full">
          <div v-for="(allowedVal,index) in allowedValues" class="tw-p-6 tw-pb-2 tw-rounded-md tw-w-full">
          <label v-text="' Arabic For ' +allowedVal+': '+Translator.translateIdAr(allowedVal,enumTypeName)"
                 class="dark:tw-text-white tw-mb-2 tw-block"/>
          <q-input
            outlined dense hide-bottom-space
            class="nama-field-input nama-customize-dense-input nama-focused-input"
            input-class="nama-input-class"
            v-model="arabicTexts[index].value"
          />
          <label v-text="' English For ' +allowedVal+': '+Translator.translateIdEn(allowedVal,enumTypeName)"
                 class="dark:tw-text-white tw-my-1 tw-block"/>
          <q-input
            outlined dense hide-bottom-space
            class="nama-field-input nama-customize-dense-input nama-focused-input"
            input-class="nama-input-class"
            v-model="englishTexts[index].value"
          />
        </div>
      </q-card-section>
        <q-separator class="tw-mt-1 dark:tw-bg-white/20 tw-bg-black/20"/>
        <q-btn
          color="primary"
          no-caps @click="onExportTranslationsClick"
          unelevated
          class="tw-rounded-md tw-mx-auto tw-mt-3 tw-shadow-sm nama-light-shadow dark:tw-text-white">
          <div class="tw-flex tw-gap-2 tw-items-center">
            <span v-text="Translator.translateId('exportTranslations')"/>
            <NamaIcon default-icon="nm-export" class="tw-size-5 active-white"/>
          </div>
        </q-btn>
      </div>
    </q-card>
  </q-dialog>
</template>
